import Link from '@mui/material/Link';
import MenuItem from '@mui/material/MenuItem';
import ButtonLoading from 'common/components/Elements/ButtonLoading/ButtonLoading';
import useFileDownload from 'common/utilities/hooks/useFileDownload/useFileDownload';
import CommandLinkContent from 'core/components/Elements/Command/CommandLinkContent/CommandLinkContent';
import type { ItemComponentProps} from 'core/components/Elements/DropDown/DropDown';
import { menuItemStyles } from 'core/components/Elements/DropDown/DropDown';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import { formatCommandUrl } from 'core/utilities/command/command';
import type React from 'react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

function ItemFileDownload({
  item, buttonRef, onClose, selected, autostart,
}: ItemComponentProps) {
  const {
    id, title, active, url,
  } = item;
  const [loading, setLoading] = useState(false);
  const { FileDownloadLoader, onStart } = useFileDownload((e) => {
    if (e) onClose(e, buttonRef);
  });
  const jsfUrl = useSelector((state: ApplicationState) => state.configuration.jsfUrl);
  const downloadFileUrl = formatCommandUrl(jsfUrl, item);

  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    // ctrl+click will open the link in a new tab, don't start the download here
    if (!e.ctrlKey) {
      e.preventDefault();
      setLoading(true);
      onStart(url as string, e);
    }
  };

  useEffect(() => {
    if (autostart) {
      handleClick(autostart);
    }
  // Only run it once
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <li role="menuitem" title={title} aria-disabled={active === false}>
      <MenuItem
        data-e2e-dropdown-item={id}
        href={downloadFileUrl}
        onClick={handleClick}
        dense
        disabled={loading || active === false}
        component={Link}
        role="link"
        sx={menuItemStyles}
        selected={selected}
      >
        <CommandLinkContent command={item} />
        {loading && (
          <ButtonLoading />
        )}
      </MenuItem>
      {FileDownloadLoader && <FileDownloadLoader />}
    </li>
  );
}

export default ItemFileDownload;
